import React from "react";

// Inject Ripple Effect CSS
const rippleStyle = `
  .ripple {
    position: absolute;
    width: 30px;
    height: 30px;
    border: 2px solid #3ba6ff;
    border-radius: 50%;
    animation: ripple-animation 2s infinite;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @keyframes ripple-animation {
    0% {
      transform: translate(-50%, -50%) scale(0.5);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0;
    }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = rippleStyle;
document.head.appendChild(styleSheet);

// Markers
export const StartMarker = ({ lat, lng }: { lat: number; lng: number }) => (
  <div style={{ position: "absolute", transform: "translate(-50%, -80%)" }}>
    <svg
      width="35"
      height="40"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7z"
        fill="#2AAB52"
        stroke="white"
        strokeWidth="1"
      />
      <text
        x="12"
        y="13"
        textAnchor="middle"
        fontSize="8"
        fill="white"
        fontWeight="bold"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        S
      </text>
    </svg>
  </div>
);

export const EndMarker = ({ lat, lng }: { lat: number; lng: number }) => (
  <div style={{ position: "absolute", transform: "translate(-50%, -80%)" }}>
    <svg
      width="35"
      height="40"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7z"
        fill="#EB445A"
        stroke="white"
        strokeWidth="1"
      />
      <text
        x="12"
        y="13"
        textAnchor="middle"
        fontSize="8"
        fill="white"
        fontWeight="bold"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        E
      </text>
    </svg>
  </div>
);

export const CurrentLocationMarker = ({
  lat,
  lng,
}: {
  lat: number;
  lng: number;
}) => (
  <div style={{ position: "relative", transform: "translate(-50%, -50%)" }}>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <rect
        x="1"
        y="1"
        width="16"
        height="16"
        rx="8"
        fill="#3ba6ff"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  </div>
);

export const LiveMarker = ({ lat, lng }: { lat: number; lng: number }) => (
  <div style={{ position: "relative", transform: "translate(-50%, -50%)" }}>
    <div className="ripple"></div>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <rect
        x="1"
        y="1"
        width="16"
        height="16"
        rx="8"
        fill="#3ba6ff"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  </div>
);